import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingView from "./LoadingView";

const UnProtectedRoute: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingView />;
  }

  if (user) {
    // All authenticated users go to unified dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default UnProtectedRoute;
